import { Component, inject, Input } from '@angular/core';
import { MessageTelegram } from "../../../../types/last-message.types";
import { TelegramModalsService } from "../../../../services/telegram-modals.service";
import { TelegramAccountsService } from "../../../../services/telegram-accounts.service";
import { LoadImageParams } from "../../../../types/telegram-page.types";
import { MatMiniFabButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'app-telegram-message-video',
  standalone: true,
  imports: [
    MatMiniFabButton,
    MatIcon
  ],
  templateUrl: './telegram-message-video.component.html',
  styleUrl: './telegram-message-video.component.scss'
})
export class TelegramMessageVideoComponent {
  @Input({ required: true }) message!: MessageTelegram;

  private telegramModalsService: TelegramModalsService = inject(TelegramModalsService);
  private telegramAccountsService: TelegramAccountsService = inject(TelegramAccountsService);

  public async handleOpenVideo(): Promise<void> {
    const loadImageParams: LoadImageParams = {
      remoteId: this.message.videoRemoteId,
      accountId: this.telegramAccountsService.selectedAccount().accountId,
      fileName: this.message.content.video?.fileName,
      fileSize: this.message.content.video?.video.size,
      mimeType: this.message.content.video?.mimeType
    };

    this.telegramModalsService.openTelegramVideoModal(loadImageParams)
  }
}
